/**
 * Backdrop dismiss that ignores text-selection / drag gestures.
 *
 * A browser `click` fires on the nearest common ancestor of mousedown and
 * mouseup. Selecting text in a dialog and releasing on the overlay therefore
 * looks like an outside click. Require the pointer to start AND end on the
 * overlay itself.
 */
const overlayIntent = new WeakMap();

function isPrimaryPointer(event) {
  return event.isPrimary !== false && (event.button === 0 || event.pointerType !== 'mouse');
}

export function overlayDismissProps(onClose) {
  if (typeof onClose !== 'function') {
    return {};
  }

  return {
    onPointerDown: (event) => {
      if (!isPrimaryPointer(event)) return;
      overlayIntent.set(event.currentTarget, event.target === event.currentTarget);
    },
    onPointerUp: (event) => {
      if (!isPrimaryPointer(event)) return;
      const startedOnOverlay = overlayIntent.get(event.currentTarget) === true;
      overlayIntent.delete(event.currentTarget);
      if (startedOnOverlay && event.target === event.currentTarget) {
        onClose();
      }
    },
  };
}
